module.exports = __webpack_public_path__ + "img/fundo_conduril.d4ab3dbc.png";